/** @format */

export class ConfigWrapper {
    private config: any;

    getApiMvnoBlockRequestById = (blockId: number): string => {
        this.config = blockId;
        return 'adescom-api/api/platform/mvno_block_requests/' + blockId;
    };

    getMaxVersionOnBlock = (): number => {
        this.config = 0;
        return 5000;
    };

    getDefaultProductDeactivationDays = (): number => {
        return 30;
    };

    public static getDefaultMnpTariffId = (): number => {
        return 31;
    };
}
